const styles = {
  Header: {
    backgroundColor: '#444 !important',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    fontSize: '24px !important',
    fontWeight: '200 !important',
    height: '9vh !important',
    color: 'white !important',
    letterSpacing: '1px !important',
  },
};

export default styles;
